import { BuyCloudPostOrderProvisioningPageTemplate } from "../../../../templates/buy/cloud/post-order-provisioning/src";

export const BuyCloudPostOrderProvisioningPage = () => (
    <BuyCloudPostOrderProvisioningPageTemplate />
);
